jQuery(document).ready(function($){
	if( $('#green_page').length ){
		var number = $('#hidden_tree_num').text().split('');
		var num_wrapper = $('#tree_count .num');
		// var html = '<span>0</span>';

		// for( var i = 0; i < number.length; i++ ){
		// 	console.log( number[i] );
		// }

		$({ Counter: 0 }).animate({ 
			Counter: num_wrapper.text()
		},{
			duration: 2500,
			easing: 'linear',
			progress: function(){
				num_wrapper.text( Math.ceil( this.Counter ) );
			}
		});
	}
});